import axios from 'axios';

const BASE_HEADERS = '';

class ApiHelper {
  // constructor() {}
  download(uri) {
    //this function is used to handle file uploads
    //here we will send get headers= true, to attach formdata header
    return axios.get(uri).then((res) => {
      // console.log('file', res.data);
    });
    // return axios
    //   .post(uri, {
    //     //note this data is formdata, the param data is embedded in previous service file itself
    //     headers: {
    //       "Content-Type": "application/pdf",
    //     },
    //     withCredentials: false,
    //     responseType: "blob",
    //   })
    //   .then((res) => {
    //     const url = window.URL.createObjectURL(new Blob([res.data]));
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute("download", "report" + ".pdf");
    //     document.body.appendChild(link);
    //     link.click();
    //   })
    //   .catch(this.handleError);
  }
  getCommon(uri: any) {
    const self = this;
    return axios
      .get(uri, {
        headers: self.getHeadersCommon(),
      })
      .then(self.checkResponse)
      .catch(self.handleError);
  }
  putCommon(uri: any, data: any) {
    const self = this;
    return axios
      .put(uri, data, {
        headers: self.getHeadersCommon(),
        withCredentials: false,
      })
      .then(self.checkResponse)
      .catch(self.handleError);
  }
  patchCommon(uri: any, data: any) {
    const self = this;
    return axios
      .put(uri, data, {
        headers: self.getHeadersCommon(),
        withCredentials: false,
      })
      .then(self.checkResponse)
      .catch(self.handleError);
  }

  postCommon(uri: any, data: any) {
    const self = this;
    return axios
      .post(uri, data, {
        headers: self.getHeadersCommon(),
        withCredentials: false,
      })
      .then(self.checkResponse)
      .catch(self.handleError);
  }
  get(uri: any) {
    const self = this;
    return axios
      .get(uri, {
        headers: self.getHeaders(),
      })
      .then(self.checkResponse)
      .catch(self.handleError);
  }

  post(uri: any, data: any) {
    const self = this;
    return axios
      .post(uri, data, {
        headers: self.getHeaders(),
        withCredentials: false,
      })
      .then(self.checkResponse)
      .catch(self.handleError);
  }

  put(uri: any, data: any) {
    const self = this;
    return axios
      .put(uri, data, {
        headers: self.getHeaders(),
        withCredentials: false,
      })
      .then(self.checkResponse)
      .catch(self.handleError);
  }
  patch(uri: any, data: any) {
    const self = this;
    return axios
      .patch(uri, data, {
        headers: self.getHeaders(),
        withCredentials: false,
      })
      .then(self.checkResponse)
      .catch(self.handleError);
  }

  remove(uri: any, data: any) {
    const self = this;
    return axios
      .delete(uri, {
        headers: self.getHeaders(),
        withCredentials: false,
        data: data,
      })
      .then(self.checkResponse)
      .catch(self.handleError);
  }

  getHeadersCommon(multipart = false) {
    let defaultHeaders: any = BASE_HEADERS;
    if (multipart) {
      defaultHeaders = {};
    }
    // if (localStorage.getItem('Token')) {
    //   defaultHeaders = {
    //     Authorization: 'Bearer ' + localStorage.getItem('Token'),
    //     ...defaultHeaders,
    //   };
    // }
    return defaultHeaders;
  }
  getHeaders(multipart = false) {
    let defaultHeaders: any = BASE_HEADERS;
    if (multipart) {
      defaultHeaders = {};
    }
    if (localStorage.getItem('token')) {
      defaultHeaders = {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        ...defaultHeaders,
      };
    }
    return defaultHeaders;
  }

  checkResponse(response: any) {
    return response;
  }

  handleError(error: any) {
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          localStorage.removeItem('token');
          //window.location.reload();
          return error.response;
        default:
          return Promise.reject(error.response);
      }
    } else {
      return Promise.reject(error.response);
    }
  }
}
export default ApiHelper;
export { ApiHelper };
